import React from 'react'

export default function index() {
    return (
        <div>
            Este es un proyecto
        </div>
    )
}
